var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"title":_vm.$t('onboarding.editCompany')}},[_c('CompanyForm',{on:{"next":_vm.success}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }